mutation UpdateProvenExpertOnLandingpage($input: UpdateProvenExpertOnLandingpageInput!) {
  updateProvenExpertOnLandingpage(input: $input) {
    company {
      showProvenExpertOnLandingpage
    }
  }
}
